// TODO: 4.0 - codemod should help to change `filterOption` to support node props.
import * as React from 'react';
import omit from 'omit.js';
import classNames from 'classnames';
import { isEmpty, isArray, intersection, split, find, defaultTo } from 'lodash';
import RcSelect, { Option, OptGroup } from 'rc-select';
import { ConfigConsumer } from '../config-provider';
import getIcons from './utils/iconUtil';
import SizeContext from '../config-provider/SizeContext';
// We still use class here since `forwardRef` not support generic in typescript
class Select extends React.Component {
    constructor() {
        super(...arguments);
        this.selectRef = React.createRef();
        this.count = 1;
        this.state = {
            multiValues: this.props.defaultValue || [],
            searchValue: '',
            options: [],
        };
        this.focus = () => {
            if (this.selectRef.current) {
                this.selectRef.current.focus();
            }
        };
        this.blur = () => {
            if (this.selectRef.current) {
                this.selectRef.current.blur();
            }
        };
        this.getMode = () => {
            const { mode } = this.props;
            if (mode === 'combobox') {
                return undefined;
            }
            if (mode === Select.SECRET_COMBOBOX_MODE_DO_NOT_USE) {
                return 'combobox';
            }
            return mode;
        };
        this.getValue = () => defaultTo(this.props.value, this.state.multiValues);
        this.handleChange = (values, option, isMatch = false) => {
            const onChange = this.props.onChange;
            if (this.count) {
                // 当输入的值可以匹配到option时会触发默认 onChange 事件，避免第二次默认事件触发
                this.count = isMatch ? -1 : 1;
            }
            // 触发默认 onChange 事件时
            if (this.count === 1) {
                this.setState({
                    multiValues: values,
                    options: option,
                });
            }
            if (onChange && this.count) {
                onChange(values, isArray(values)
                    ? values.map((item) => find(option, { value: item }) || { value: item })
                    : option);
                this.count += 1;
            }
            else {
                this.count = 1;
            }
        };
        this.onSearch = (searchValue) => {
            this.setState({ searchValue });
            const { tokenSeparators = [], onSearch } = this.props;
            const mode = this.getMode();
            if (onSearch)
                onSearch(searchValue);
            if (!isEmpty(tokenSeparators) && mode === 'multiple') {
                const separators = intersection(split(searchValue, ''), tokenSeparators);
                const values = split(searchValue, separators[0]).filter(item => item);
                const options = values.map((item) => find(this.state.options, { value: item }) || { value: item });
                if (!isEmpty(separators)) {
                    this.handleChange([...new Set([...this.getValue(), ...values])], options);
                    this.setState({
                        searchValue: '',
                    }, () => {
                        this.blur();
                        this.focus();
                    });
                }
            }
        };
        this.onInputKeyDown = (e) => {
            e.persist();
            const { searchValue, options } = this.state;
            const { onInputKeyDown, onChange } = this.props;
            if (onInputKeyDown)
                onInputKeyDown(e);
            if (e.keyCode === 13 && searchValue) {
                const values = [...new Set([...this.getValue(), searchValue])];
                if (onChange) {
                    let allValues = this.props.children || [];
                    allValues = allValues.map((item) => { var _a, _b; return (_b = (_a = item.props) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : item.key; });
                    this.handleChange(values, values.map((item) => find(options, { value: item }) || { value: item }), !!find(allValues, (item) => item.includes(searchValue)));
                }
                this.setState({
                    multiValues: values,
                    searchValue: '',
                }, () => {
                    this.blur();
                    this.focus();
                });
            }
        };
        this.renderSelect = ({ getPopupContainer: getContextPopupContainer, getPrefixCls, 
        // renderEmpty,
        direction, }) => {
            const { prefixCls: customizePrefixCls, notFoundContent, className, size: customizeSize, listHeight = 256, listItemHeight = 32, getPopupContainer, dropdownClassName, bordered, addNewValue, } = this.props;
            const prefixCls = getPrefixCls('select', customizePrefixCls);
            const mode = this.getMode();
            const isMultiple = mode === 'multiple' || mode === 'tags';
            // ===================== Empty =====================
            let mergedNotFound;
            if (notFoundContent !== undefined) {
                mergedNotFound = notFoundContent;
            }
            else if (mode === 'combobox') {
                mergedNotFound = null;
            }
            else {
                // mergedNotFound = renderEmpty('Select');
                mergedNotFound = '暂无数据';
            }
            // ===================== Icons =====================
            const { itemIcon, suffixIcon, removeIcon, clearIcon } = getIcons(Object.assign(Object.assign({}, this.props), { multiple: isMultiple, prefixCls,
                bordered }));
            // ===================== addNewValue =====================
            let selectProps = omit(this.props, [
                'prefixCls',
                'suffixIcon',
                'itemIcon',
                'removeIcon',
                'clearIcon',
                'size',
                'bordered',
                'addNewValue',
            ]);
            if (mode === 'multiple' && addNewValue) {
                selectProps = Object.assign(Object.assign({}, omit(selectProps, [
                    'tokenSeparators',
                    'value',
                    'onSearch',
                    'onChange',
                    'onInputKeyDown',
                ])), { value: this.getValue(), onSearch: this.onSearch, onChange: this.handleChange, onInputKeyDown: this.onInputKeyDown });
            }
            const rcSelectRtlDropDownClassName = classNames(dropdownClassName, {
                [`${prefixCls}-dropdown-${direction}`]: direction === 'rtl',
            });
            return (<SizeContext.Consumer>
        {size => {
                const mergedSize = customizeSize || size;
                const mergedClassName = classNames(className, {
                    [`${prefixCls}-lg`]: mergedSize === 'large',
                    [`${prefixCls}-sm`]: mergedSize === 'small',
                    [`${prefixCls}-md`]: mergedSize === 'middle',
                    [`${prefixCls}-rtl`]: direction === 'rtl',
                    [`${prefixCls}-borderless`]: !bordered,
                });
                return (<RcSelect ref={this.selectRef} {...selectProps} listHeight={listHeight} listItemHeight={listItemHeight} mode={mode} prefixCls={prefixCls} direction={direction} inputIcon={suffixIcon} menuItemSelectedIcon={itemIcon} removeIcon={removeIcon} clearIcon={clearIcon} notFoundContent={mergedNotFound} className={mergedClassName} getPopupContainer={getPopupContainer || getContextPopupContainer} dropdownClassName={rcSelectRtlDropDownClassName}/>);
            }}
      </SizeContext.Consumer>);
        };
    }
    render() {
        return <ConfigConsumer>{this.renderSelect}</ConfigConsumer>;
    }
}
Select.Option = Option;
Select.OptGroup = OptGroup;
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
Select.defaultProps = {
    transitionName: 'slide-up',
    choiceTransitionName: 'zoom',
    bordered: true,
    addNewValue: false,
};
export default Select;
